var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 94,
    viewBox: "0 0 79 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2661465"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5745_16265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.1523 64.332L54.7079 92.1045L75.2192 67.4089L52.1523 64.332Z",
    fill: "#FFC67C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.0758 0L66.2061 68.392H71.4526C75.799 68.392 79.3223 64.5857 79.3223 59.8903V1.41696C79.3223 0.634421 78.7351 0 78.0107 0H74.0758Z",
    fill: "#FFD88D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M73.4386 59.9557V0H1.17942C0.528066 0 0 0.635115 0 1.41851V92.5815C0 93.3649 0.528066 94 1.17942 94H49.8502C53.7585 94 56.9267 90.1895 56.9267 85.4889V68.4668H66.3621C70.2704 68.4668 73.4386 64.6563 73.4386 59.9557Z",
    fill: "#F8F4E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5745_16265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.0731,
    height: 94,
    rx: 2.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.0133ac76d2af7cffc907766225a4ebd8.svg";
export { ForwardRef as ReactComponent };